import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInstance";

const BASE_URL = "/api/v1/billing";

// Fetch seller billing data
export const fetchSellerBilling = createAsyncThunk(
  "billing/fetchSellerBilling",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/seller`);
      console.log("response", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch billing");
    }
  }
);

// Trigger manual billing (admin only)
export const triggerManualBilling = createAsyncThunk(
  "billing/triggerManualBilling",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/admin/trigger-billing`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to trigger billing");
    }
  }
);

// Mark bill as paid
export const markBillAsPaid = createAsyncThunk(
  "billing/markBillAsPaid",
  async ({ billId, paymentDetails }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/mark-paid/${billId}`, paymentDetails);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to mark as paid");
    }
  }
);

const billingSlice = createSlice({
  name: "billing",
  initialState: {
    billingData: null,
    loading: false,
    error: null,
    paymentProcessing: false,
    paymentSuccess: false
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetPaymentState: (state) => {
      state.paymentProcessing = false;
      state.paymentSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Seller Billing
      .addCase(fetchSellerBilling.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSellerBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.billingData = action.payload;
      })
      .addCase(fetchSellerBilling.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Trigger Manual Billing
      .addCase(triggerManualBilling.pending, (state) => {
        state.loading = true;
      })
      .addCase(triggerManualBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.billingData = action.payload;
      })
      .addCase(triggerManualBilling.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Mark Bill as Paid
      .addCase(markBillAsPaid.pending, (state) => {
        state.paymentProcessing = true;
        state.paymentSuccess = false;
      })
      .addCase(markBillAsPaid.fulfilled, (state, action) => {
        state.paymentProcessing = false;
        state.paymentSuccess = true;
        if (state.billingData) {
          state.billingData.summary.billStatus = "paid";
          state.billingData.summary.amounts.pendingAmount = 0;
          state.billingData.summary.amounts.totalPaidAmount = 
            state.billingData.summary.amounts.totalBillingAmount;
        }
      })
      .addCase(markBillAsPaid.rejected, (state, action) => {
        state.paymentProcessing = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, resetPaymentState } = billingSlice.actions;
export default billingSlice.reducer;